import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/tips／exclamation-circle-fill@2x.png'
import _imports_1 from '@/assets/img/weixin.png'
import _imports_2 from '@/assets/img/zhifubao.png'
import _imports_3 from '@/assets/ewm.jpg'


const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "requirement_management comBox" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  class: "right",
  style: {"position":"relative"}
}
const _hoisted_5 = { style: {"display":"flex","position":"absolute","top":"0.1rem","right":"0.16rem","z-index":"1"} }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "table_information" }
const _hoisted_8 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","-webkit-box-orient":"vertical","-webkit-line-clamp":"1","color":"#333333","font-size":"0.16rem","font-weight":"bold"} }
const _hoisted_9 = { style: {"display":"flex","justify-content":"flex-start","margin-top":"0.04rem"} }
const _hoisted_10 = { style: {"display":"flex","width":"1rem","margin-right":"0.4rem"} }
const _hoisted_11 = { style: {"width":"2rem","display":"flex","margin-right":"0.2rem"} }
const _hoisted_12 = { style: {"width":"2rem","display":"flex","margin-right":"0.2rem"} }
const _hoisted_13 = { style: {"color":"#c01a26"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  style: {"font-size":"0.14rem","color":"#000000","text-align":"center","width":"100%"}
}
const _hoisted_21 = {
  key: 2,
  style: {"font-size":"0.14rem","color":"#000000","text-align":"center","width":"100%"}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 3,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 4,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  style: {"font-size":"0.14rem","color":"#000000","text-align":"center","width":"100%"}
}
const _hoisted_30 = { style: {"display":"flex","justify-content":"space-around","width":"100%"} }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "topBtn",
  style: {"width":"50%","padding":"0 0","margin-left":"0","background":"transparent","border":"1px solid #9aa2ac","color":"#9aa2ac"}
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 5,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 6,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_37 = { style: {"display":"flex","justify-content":"space-around","width":"100%"} }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 1,
  class: "topBtn",
  style: {"width":"50%","padding":"0 0","margin-left":"0","background":"transparent","border":"1px solid #9aa2ac","color":"#9aa2ac"}
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 3,
  style: {"width":"50%","padding":"0 0","margin-left":"0.2rem"},
  class: "topBtn1"
}
const _hoisted_42 = ["href", "download"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { style: {"display":"flex","justify-content":"space-around","width":"100%"} }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_47 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_48 = {
  class: "rate",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_49 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_50 = { style: {"font-size":"0.2rem","font-weight":"bold"} }
const _hoisted_51 = { style: {"margin":"0.12rem 0 0.24rem","font-size":"0.14rem","display":"flex"} }
const _hoisted_52 = { style: {"color":"#333333","font-size":"0.14rem","line-height":"0.3rem"} }
const _hoisted_53 = { style: {"display":"flex","justify-content":"flex-start"} }
const _hoisted_54 = ["href"]
const _hoisted_55 = { style: {"display":"flex"} }
const _hoisted_56 = { style: {"font-size":"0.24rem","color":"#c01a26"} }
const _hoisted_57 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_58 = { style: {"display":"flex","justify-content":"flex-start"} }
const _hoisted_59 = ["href"]
const _hoisted_60 = { style: {"display":"flex","justify-content":"center","margin-top":"0.01rem"} }
const _hoisted_61 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_62 = { style: {"display":"flex","justify-content":"center","font-size":"0.14rem","margin-bottom":"0.2rem","margin-top":"0.2rem"} }
const _hoisted_63 = { style: {"font-size":"0.24rem","color":"#c01a26","margin-top":"-0.09rem"} }
const _hoisted_64 = { style: {"display":"flex"} }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { style: {"width":"0.24rem","height":"0.24rem","margin-right":"0.04rem"} }
const _hoisted_67 = {
  key: 0,
  src: _imports_1,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_68 = {
  key: 1,
  src: _imports_2,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_69 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_70 = { style: {"font-size":"0.12rem","display":"flex","justify-content":"center","margin-top":"0.16rem","margin-bottom":"0.2rem"} }
const _hoisted_71 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_72 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_73 = {
  class: "rate",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_74 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_75 = {
  key: 0,
  style: {"font-size":"0.12rem","display":"flex","align-items":"center","justify-content":"flex-start","margin-top":"0.16rem","margin-bottom":"0.2rem"}
}
const _hoisted_76 = { style: {"display":"flex","justify-content":"center","margin-top":"10px"} }
const _hoisted_77 = { style: {"text-align":"center","padding-top":"5px","font-size":"20px"} }
const _hoisted_78 = { style: {"display":"flex","justify-content":"center"} }

import numberOfApplicantsSelect from "@/components/numberOfApplicantsSelect.vue";
import numberOfApplicants from "@/components/numberOfApplicants.vue";
import leftTemplate3 from "@/components/leftTemplate3.vue";
import customPopUps from "@/components/custom-pop-ups.vue";
import { ref, reactive, onMounted, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import type { TabsPaneContext } from "element-plus";
import { ElTable } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import com_date from "@/assets/js/common.js";
import { ElMessage, ElLoading } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import TwoDimensionalCode from "./components/TwoDimensionalCode.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import axios from "axios";
import { json } from "stream/consumers";
type Form = {
  contactInfo: string;
  deliveryTime: string;
  price: number;
  projectName: string;
  projectDescription: string;
  skillType: string;
  workPlace: string;
};
type Rules = {
  [K in keyof Form]?: Array<FormItemRule>;
};
interface User {
  date: string;
  name: string;
  price: string;
  address: string;
  katype: string;

  number: number;
  time: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'requirement_publish',
  setup(__props) {

const TwoDimensionalCodeRef = ref<any>();
const numberOfApplicantsSelectRef = ref<any>();
document.title = "标识山西-发布的需求";
const dialogTableVisible = ref(false);
const activeName = ref("first1");
const route = useRoute();
const router = useRouter();
const PartnersMobileNumber = ref(false);
const chuan = ref("requirement_publish");
const dialogVisible = ref(false);
const disabledDate = (time) => {
  return time.getTime() < Date.now();
};

const activeList = ref([
  {
    label: "已发布",
    name: "first1",
    satus: 1,
  },
  {
    label: "待确认",
    name: "first",
    satus: 2,
  },
  {
    label: "待合作", // 已付款
    name: "first2",
    satus: 3,
  },
  {
    label: "进行中",
    name: "second",
    satus: 4,
  },
  {
    label: "待评价",
    name: "third",
    satus: 5,
  },
  {
    label: "已终止",
    name: "four",
    satus: 6,
  },
  {
    label: "已评价",
    name: "four12",
    satus: 7,
  },
  {
    label: "已退款",
    name: "four3",
    satus: 8,
  },
]);
const radio = ref(false);
const form = ref({
  condition: {
    state: 1,
  },
  pageIndex: 1,
  pageSize: 12,
  total: 0,
});
const checked = ref(false);
const form1 = ref({
  contactInfo: "",
  deliveryTime: "",
  price: null,
  projectName: "",
  workName: "",
  projectDescription: "",
  skillType: "",
  workPlace: "",
});

const ckBtn = (item: any) => {
  title2.value = "查看发布需求";
  checked.value = true;
  form1.value = item;
}
const formRef = ref<FormInstance>();
const rules = reactive<FormRules<RuleForm>>({
  contactInfo: [
    { required: true, message: "请输入联系方式", trigger: "change" },
  ],
  deliveryTime: [
    { required: true, message: "请选择交付日期", trigger: "change" },
  ],
  price: [{ required: true, message: "请输入价格", trigger: "change" }, {
    validator: (rule, value, cb) => {
      if (String(value).trim() == 'null') return;
      if (String(value).indexOf(".") != -1) {
        return cb(new Error('请输入正整数'));
      }
      return cb();
    }, trigger: 'blur'
  }],
  projectName: [
    { required: true, message: "请输入项目名称", trigger: "change" },
  ],
  projectDescription: [
    { required: true, message: "请输入项目描述", trigger: "change" },
  ],
});
const dialogEvaluateVisible1 = ref(false);
const EvaluationContentObj = ref({});
const EvaluationContentList = ref([]);
const anewSend = (item: any) => {
  title2.value = '发布需求';
  checked.value = true;
  let {
    contactInfo,
    deliveryTime,
    price,
    projectName,
    workName,
    projectDescription,
    skillType,
    workPlace } = JSON.parse(JSON.stringify(item))
  form1.value = {
    contactInfo,
    deliveryTime,
    price,
    projectName,
    workName,
    projectDescription,
    skillType,
    workPlace
  };
}
const myDebitView = (row) => {
  router.push({
    path: "/invoiceDebit",
    query: {
      arry: row.id,
      type: "add",
      type1: "1",
      price: row.price,
      needNo: row.needNo,
    },
  });
};

const Details = (index, row) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: row.partnerId },
  });
};
const EvaluationContent = (index, row) => {
  dialogVisible.value = true;
  EvaluationContentObj.value.id = row.id;
  Axios(
    "post",
    "/material//material/need/listEvaluate",
    {
      pageIndex: 1,
      pageSize: 20,

      condition: {
        needId: EvaluationContentObj.value.id,
      },
    },
    false,
    function (res) {
      if (res.data.code == 200) {
        console.log(
          "res.data.data.records.records,records",
          res.data.data.records[0]
        );
        if (res.data.data.records && res.data.data.records.length > 0) {
          res.data.data.records.forEach((e) => {
            if (
              e.evaluate_user_id ==
              JSON.parse(localStorage.getItem("userList")).memberId
            ) {
              e.BothParties = "甲方";
            } else {
              e.BothParties = "乙方";
            }
          });
        }
        EvaluationContentList.value = res.data.data.records;

        // EvaluationContentObj.value = res.data.data.records[0];
      } else {
        console.log(res);
      }
    }
  );
};
const submitForm = () => {
  if (!radio.value) {
    return ElMessage.error("请同意合同协议");
  }
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let obj = { ...form1.value };
      Axios("POST", "/material/material/need/sou", obj, false, function (res) {
        if (res.data.code == 200) {
          handleClose(true);
        } else {
          ElMessage.error(res.data.message);
        }
      });
    } else {
      return false;
    }
  });
};
const handleClose1 = () => {
  dialogEvaluateVisible.value = false;
  evaluateObj.value = {};
};
// const handleClose = (e: any) => {
//   checked.value = false;
//   form1.value = {
//     contactInfo: "",
//     deliveryTime: "",
//     price: null,
//     projectName: "",
//     workName: "",
//     projectDescription: "",
//     // signUpNum: null,
//     skillType: "",
//     workPlace: "",
//   };
//   // Check if formRef.value exists before accessing resetFields()
//   formRef.value && formRef.value.resetFields();
//   radio.value = false;
//   if (e) {
//     getList();
//   }
// };
const handleClose = (e) => {
  formRef.value.clearValidate();
  formRef.value.resetFields();
  radio.value = false;
  checked.value = false;
  if (e) {
    getList();
  }
};
const handleClick = (tab: TabsPaneContext, event: Event) => {
  activeList.value.forEach((e) => {
    if (e.name == tab.props.name) {
      form.value.condition.state = e.satus;
    }
  });
  list.value = [];
  getList();
};
const openagreement = (val) => {
  window.open(`/agreement?name=${val}`, "_bank");
};
watch(
  () => route.query.state,
  async (params) => {
    await nextTick();
    activeName.value = route.query.state ? route.query.state : "first1";
    handleClick({ props: { name: activeName.value } });
  },
  { immediate: true }
);
const handleDelete = (index, row) => {
  console.log(index, row);
};
const isMacOs = () => {
  return window.navigator.userAgent.includes("Macintosh");
};

const downloadImage = (imgsrc, name) => {
  const link = document.createElement("a");
  link.href = imgsrc;
  link.download = name;

  if (!isMacOs()) {
    // 如果不是 MacOS 则添加 target 属性
    link.target = "_blank";
  }

  document.body.appendChild(link);
  link.dispatchEvent(new MouseEvent("click"));
  document.body.removeChild(link);
};

// 表格
// 左侧点击
// condition中包state字段(待签单state = 1 / 已报名state = 0 /待确认 state = 2 / 已拒绝state = 3 / 进行中 state= 4 /待评价 state = 5 / 已评价 state = 6)
const list = ref([]);
const getList = () => {
  let obj = { ...form.value };
  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  let obj1 = { ...obj.condition };
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  obj.condition = obj1;
  Axios(
    "post",
    "/material/material/need/myPublish",
    obj,
    false,
    function (res) {
      // console.log(res.data.code);

      if (res.data.code == 200) {
        list.value = res.data.data.records;
      } else {
        console.log(res);
      }
    }
  );
};
const title2 = ref("");
getList();
const getInfo = (index, row) => {
  Axios("get", `/material/material/need/${row.id}`, {}, false, function (res) {
    // console.log(res.data.code);
    if (res.data.code == 200) {
      title2.value = "查看发布需求";
      checked.value = true;
      form1.value = res.data.data;
      // list.value = res.data.data.records;
    } else {
      console.log(res);
    }
  });
};
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
var data = []; // 创建一个空数组

for (var i = 0; i < 10; i++) {
  data.push({
    id: "45648941615641",
    name: "5月24日广州南沙活动拍摄",

    price: "￥5000.00",
    time: "2023-06-08 15:14",
    katype: 1,
    faid: "/",
    number: 34,
  }); // 将相同的数据添加到数组中
}
const tableData: User[] = data;
// 删除
let dialogDelVisible = ref(false);
const ids = ref([]);
const handleDel = (index, row) => {
  ids.value = [];
  ids.value.push(row.id);
  dialogDelVisible.value = true;
};
const dlt = () => {
  Axios(
    "post",
    "/material/material/need/del",
    ids.value,
    false,
    function (res) {
      // console.log(res.data.code);

      if (res.data.code == 200) {
        ElMessage.success("删除成功");
        dialogDelVisible.value = false;
        getList();
      } else {
        console.log(res);
      }
    }
  );
};
//评价
let dialogEvaluateVisible = ref(false);
const handleEvaluate = (index, row, type) => {
  evaluateObj.value.needId = row.id;
  dialogEvaluateVisible.value = true;
};
let evaluateObj = ref({});
const evaluate = () => {
  evaluateObj.value.type = 1;
  if (!evaluateObj.value.evaluateStar || !evaluateObj.value.evaluateContent) {
    return ElMessage.warning("内容不能为空，请选择评级和输入内容");
  }
  Axios(
    "post",
    "/material//material/need/evaluate",
    evaluateObj.value,
    false,
    function (res) {
      if (res.data.code == 200) {
        dialogEvaluateVisible.value = false;
        evaluateObj.value = {};
        ElMessage.success("评价成功");
        getList();
      } else {
        console.log(res);
      }
    }
  );
};
//合作
let dialogCooperationVisible = ref(false);
const handleCooperation = (index, row, type) => {
  dialogCooperationVisible.value = true;
};
//确认合作
let cooperationVisible = ref(false);
let obj = ref({});
const handleCooperationVerify = (index, row, type) => {
  cooperationVisible.value = true;
  obj.value = row;
};
const Verify = () => {
  let obj1 = { ...obj.value };
  Axios("post", "/material/material/need/confirm", obj1, false, function (res) {
    if (res.data.code == 200) {
    } else {
      console.log(res);
    }
  });
};
// 选择合伙人
let obj1 = ref({});
const selectPeople = (item) => {
  obj1.value.id = item.id;
  console.log(obj1.value.id);
  numberOfApplicantsSelectRef.value.forEach((e) => {
    e.init();
  });
};
let payVisible = ref(false);
const handlePay = () => {
  if (JSON.stringify(obj1.value) != "{}") {
    let id;
    for (const e of numberOfApplicantsSelectRef.value) {
      if (e.radio) {
        console.log(e.radio);
        id = e.radio;
        break; // 停止循环
      }
    }
    if (id) {
      Axios(
        "post",
        `/material/material/need/choiceUser?id=${obj1.value.id}`,
        {},
        false,
        function (res) {
          if (res.data.code == 200) {
            ElMessage.success("选择合伙人成功");
            peopleSelectVisible.value = false;
            getList();
            console.log(res);
          } else {
            console.log(res);
          }
        }
      );
    } else {
      ElMessage.warning("请选择选择合作人");
    }

    //payVisible.value = true;
  } else {
    ElMessage.warning("请选择选择合作人");
  }
};

// 付款
const Payment = ref({});
const PaymentChoice = (index, row) => {
  Payment.value.price = row.price;
  Payment.value.id = row.id;
  payVisible.value = true;
};
const PartnersMobileNumber1 = ref();
const CloseQrCode = (e) => {
  payVisible.value = false;
  getList();
  Axios("get", `/material/material/need/${e}`, "", false, function (res) {
    if (res.data.code == 200) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    } else {
      console.log(res);
    }
  });
};
const Payment1 = () => {
  if (Payment.value.value === "zfb") {
    let id = Payment.value.id;
    Axios(
      "post",
      `/material/material/need/create-pay/ALIPAY/${id}`,
      {},
      false,
      function (res) {
        if (res.data.code == 200) {
          Payment.value.img = res.data.data.qrcode;
          TwoDimensionalCodeRef.value.init(
            Payment.value.img,
            res.data.data.sceneId,
            id
          );
        } else {
          console.log(res);
        }
      }
    );
  } else {
    if (Payment.value.value === "wx") {
      let id = Payment.value.id;
      Axios(
        "post",
        `/material/material/need/create-pay/WXPAY/${id}`,
        {},
        false,
        function (res) {
          if (res.data.code == 200) {
            Payment.value.img = res.data.data.qrcode;
            TwoDimensionalCodeRef.value.init(
              Payment.value.img,
              res.data.data.sceneId,
              id
            );
          } else {
            console.log(res);
          }
        }
      );
    } else {
      ElMessage.warning("请选择付款方式");
    }
  }
};
//结算
let settlementObj = ref({});
let dialogAccountVisible = ref(false);
const handleAccount = (index, row, type) => {
  if (!Array.isArray(row._deliveryFileArray)) {
    row._deliveryFileArray = row.deliveryFile.split(",");
    row.deliveryFile = row._deliveryFileArray.map((url) => {
      // 使用正则表达式提取URL中的文件名部分
      const name = getFileName(url);
      return { name, url };
    });
  }

  settlementObj.value = row;
  dialogAccountVisible.value = true;
};
const getFileName = (file) => {
  file = file.slice(0, file.lastIndexOf("?"));
  file = file.slice(file.lastIndexOf("/") + 1);
  const prefix = file.substring(file.lastIndexOf("_"), file.lastIndexOf("."));
  file = file.replace(prefix, "");
  return decodeURI(file);
};
const SettleAnAccount = () => {
  // console.log(settlementObj.value.hasOwnProperty("deliveryFile"));
  let obj = { ...settlementObj.value };

  if (obj && obj.hasOwnProperty("deliveryFile")) {
    delete obj.deliveryFile;
  } else {
    console.log(123);
  }
  // return console.log(1231);

  Axios(
    "post",
    `/material/material/need/settlement`,
    obj,
    false,
    function (res) {
      if (res.data.code == 200) {
        ElMessage.success("结算成功");
        getList();
        dialogAccountVisible.value = false;
      } else {
        console.log(res);
      }
    }
  );
};
//文件查看

let dialogAccountViewVisible = ref(false);
const handleFileView = (index, row, type) => {
  if (!row.deliveryFile) return ElMessage.warning("等待对方交付...");

  if (!Array.isArray(row._deliveryFileArray)) {
    row._deliveryFileArray = row.deliveryFile.split(",");
    row.deliveryFile = row._deliveryFileArray.map((url) => {
      // 将 HTTP 替换为 HTTPS
      const httpsUrl = url.replace("http://", "https://");

      const name = getFileName(httpsUrl);
      return { name, url: httpsUrl };
    });
  }
  settlementObj.value = row;
  dialogAccountViewVisible.value = true;
};
//查看报名人数
let peopleVisible = ref(false);
const handlePeople = (index, row, type) => {
  peopleVisible.value = true;
};

// 合作人选择
const list1 = ref({});
const loading = ref(null);
let peopleSelectVisible = ref(false);
let params = {
  pageIndex: 1,
  pageSize: 5,
  needId: "",
};
const title1 = ref("");
const handlePeopleSelect = async (index, row, type) => {
  params.needId = row.id;
  console.log();
  if (row.signUpNum) {
    loading.value = ElLoading.service({
      lock: true,
      text: "Loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    Axios(
      "GET",
      "/material/material/need/signUpInfo",
      params,
      false,
      function (res) {
        if (res.data.code == 200) {
          list1.value = res.data.data.records;
          form.value.total = res.data.data.total;
          loading.value.close();
        } else {
          console.log(res);
        }
      }
    );
    obj1.value = {};
    title1.value = "选择合伙人";

    peopleSelectVisible.value = true;
    // console.log();
    let a = function () {
      numberOfApplicantsSelectRef.value.forEach((e) => {
        e.init();
      });
    };
    numberOfApplicantsSelectRef.value ? a() : "";
  } else {
    ElMessage.warning("该需求暂无合作人");
  }
};
let params1 = {
  pageIndex: 1,
  pageSize: 5,
  needId: "",
};
const handlePeopleSelect1 = (index, row, type) => {
  params1.needId = row.id;
  if (row.signUpNum) {
    Axios(
      "GET",
      "/material/material/need/signUpInfo",
      params1,
      false,
      function (res) {
        if (res.data.code == 200) {
          list1.value = res.data.data.records;
          form.value.total = res.data.data.total;
        } else {
          console.log(res);
        }
      }
    );
    obj1.value = {};
    title1.value = "查看合伙人";
    peopleSelectVisible.value = true;
  } else {
    ElMessage.warning("该需求暂无合作人");
  }
};
//客服
let serviceVisible = ref(false);
const handleService = (index, row, type) => {
  serviceVisible.value = true;
};
// 选择支付方式
const paymentOptions = ref([
  { name: "微信", icon: "@/assets/img/weixin.png", value: "wx" },
  { name: "支付宝", icon: "@/assets/img/zhifubao.png", value: "zfb" },
]);

const selectedPaymentOption = ref(null);

const selectPaymentOption = (option) => {
  selectedPaymentOption.value = option;
  Payment.value.value = option.value;
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate3, { left_tabShow: chuan.value }, null, 8, ["left_tabShow"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[48] || (_cache[48] = _createElementVNode("div", { style: {"height":"0.08rem"} }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            style: {"cursor":"pointer"},
            class: "topBtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
            title2.value = '发布需求';
          checked.value = true;
          })
          }, " 发布需求 "),
          _createElementVNode("div", {
            style: {"cursor":"pointer","color":"#333333","background":"transparent","border":"1px solid #e5e6eb"},
            class: "topBtn",
            onClick: handleService
          }, " 联系客服 ")
        ]),
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                label: item.label,
                name: item.name,
                key: item
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElTable), {
                    ref_for: true,
                    ref_key: "multipleTableRef",
                    ref: multipleTableRef,
                    data: list.value,
                    style: {"width":"100%"},
                    height: "650"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "需求内容"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(scope.row.projectName), 1),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, [
                                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "table_title" }, "工作地点：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: scope.row.workPlace ? scope.row.workPlace : '暂无'
                            
                                  }, null, 8, ["text"])
                                ]),
                                _createElementVNode("span", _hoisted_11, [
                                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "table_title" }, "交付时间：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: _unref(com_date).com_date.timestamp_string(
                            scope.row.deliveryTime,
                            false,
                            `-`,
                            `:`
                          )
                            
                                  }, null, 8, ["text"])
                                ]),
                                _createElementVNode("span", _hoisted_12, [
                                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "table_title" }, "技能类型：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: scope.row.skillType ? scope.row.skillType : `暂无`
                            
                                  }, null, 8, ["text"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "需求预算",
                        width: "150",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(scope.row.price ? "￥" : "") + _toDisplayString((scope.row.price / 1).toFixed(2)), 1)
                        ]),
                        _: 1
                      }),
                      (activeName.value == 'first1')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            label: "报名人数",
                            width: "150",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                style: {"color":"#3fa4ed"},
                                onClick: ($event: any) => (handlePeopleSelect1(_ctx.index, scope.row))
                              }, _toDisplayString(scope.row.signUpNum), 9, _hoisted_14)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (activeName.value == 'second')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 1,
                            label: "需求文件",
                            width: "90",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                style: {"color":"#3fa4ed"},
                                onClick: ($event: any) => (handleFileView(scope.$index, scope.row))
                              }, " 查看 ", 8, _hoisted_15)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (activeName.value != 'first1')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 2,
                            label: "合作人",
                            width: "150",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("span", {
                                onClick: ($event: any) => (Details(scope.$index, scope.row))
                              }, _toDisplayString(scope.row.partner), 9, _hoisted_16)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (activeName.value != 'four3')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 3,
                            label: "操作",
                            width: 355,
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              (activeName.value == 'first1' &&
                    scope.row.delFlag != 1 &&
                    scope.row.choiceFlag == 0
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("div", {
                                      class: "topBtn",
                                      onClick: ($event: any) => (handlePeopleSelect(scope.$index, scope.row))
                                    }, " 选择合作人 ", 8, _hoisted_18),
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (handleDel(scope.$index, scope.row)),
                                      style: {"margin-left":"0.1rem","line-height":"0.43rem","color":"red","flex":"none"}
                                    }, " 删除 ", 8, _hoisted_19)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'first1' &&
                    scope.row.delFlag != 1 &&
                    scope.row.choiceFlag == 1
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 等待对方签单... "))
                                : _createCommentVNode("", true),
                              (activeName.value == 'first2')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (scope.row.expireFlag == 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "等待对方合作..."))
                                      : _createCommentVNode("", true),
                                    (scope.row.expireFlag == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 未确认合作,订单已过期 "))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'first')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (scope.row.payFlag == 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _createElementVNode("div", {
                                            class: "topBtn",
                                            onClick: ($event: any) => (PaymentChoice(scope.$index, scope.row))
                                          }, " 付款 ", 8, _hoisted_26),
                                          _cache[47] || (_cache[47] = _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 24小时未确认合作，订单将取消 ", -1))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'second')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    (scope.row.deliveryFile)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "topBtn",
                                          onClick: ($event: any) => (handleAccount(scope.$index, scope.row))
                                        }, " 结算 ", 8, _hoisted_28))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_29, " 等待对方交付... "))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_30, [
                                (activeName.value == 'third' && scope.row.invoicingFlag == 0
                        )
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "topBtn",
                                      style: {"width":"50%","padding":"0 0","margin-left":"0","background":"transparent","border":"1px solid #c01a26","color":"#c01a26"},
                                      onClick: ($event: any) => (myDebitView(scope.row))
                                    }, " 申请发票 ", 8, _hoisted_31))
                                  : _createCommentVNode("", true),
                                (activeName.value == 'third' && scope.row.invoicingFlag == 1
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 已申请 "))
                                  : _createCommentVNode("", true),
                                (activeName.value == 'third')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      class: "topBtn",
                                      style: {"width":"50%","padding":"0 0","margin-left":"0.2rem"},
                                      onClick: ($event: any) => (handleEvaluate(scope.$index, scope.row))
                                    }, " 合作评价 ", 8, _hoisted_33))
                                  : _createCommentVNode("", true)
                              ]),
                              (activeName.value == 'five')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (handleDel(scope.$index, scope.row)),
                                      style: {"margin-left":"0.1rem","line-height":"0.43rem","color":"#ff2929"}
                                    }, " 删除 ", 8, _hoisted_35)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'four12')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_37, [
                                (activeName.value == 'four12' && scope.row.invoicingFlag == 0
                        )
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "topBtn",
                                      style: {"width":"50%","padding":"0 0","margin-left":"0","background":"transparent","border":"1px solid #c01a26","color":"#c01a26"},
                                      onClick: ($event: any) => (myDebitView(scope.row))
                                    }, " 申请发票 ", 8, _hoisted_38))
                                  : _createCommentVNode("", true),
                                (activeName.value == 'four12' && scope.row.invoicingFlag == 1
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 已申请 "))
                                  : _createCommentVNode("", true),
                                (activeName.value == 'four12')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      onClick: ($event: any) => (ckBtn(scope.row)),
                                      style: {"width":"50%","padding":"0 0","margin-left":"0.2rem","cursor":"pointer"},
                                      class: "topBtn1"
                                    }, " 查看 ", 8, _hoisted_40))
                                  : _createCommentVNode("", true),
                                (activeName.value == 'four12')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _createElementVNode("a", {
                                        href: scope.row.deliveryFile,
                                        style: {"color":"#FFF"},
                                        download: scope.row.projectName
                                      }, "下载", 8, _hoisted_42)
                                    ]))
                                  : _createCommentVNode("", true),
                                (activeName.value == 'four12')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 4,
                                      onClick: ($event: any) => (EvaluationContent(scope.$index, scope.row)),
                                      style: {"width":"50%","padding":"0 0","margin-left":"0.2rem"},
                                      class: "topBtn1"
                                    }, " 评价列表 ", 8, _hoisted_43))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                (activeName.value == 'four')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      onClick: ($event: any) => (anewSend(scope.row)),
                                      style: {"width":"50%","padding":"0 0","margin-left":"0.2rem","cursor":"pointer"},
                                      class: "topBtn1"
                                    }, " 重新发布 ", 8, _hoisted_45))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (dialogVisible.value)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          title: "评价列表",
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
          width: "480px",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            (EvaluationContentList.value.length)
              ? (_openBlock(), _createBlock(_unref(ElTable), {
                  key: 0,
                  data: EvaluationContentList.value,
                  style: {"width":"100%"},
                  "header-cell-style": { 'text-align': 'center' },
                  "cell-style": { 'text-align': 'center' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "序号",
                      type: "index",
                      width: "60"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "评价星级",
                      prop: "evaluate_star"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "评价内容",
                      prop: "evaluate_content"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "评价方",
                      prop: "BothParties"
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(dialogDelVisible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(dialogDelVisible) ? (dialogDelVisible).value = $event : dialogDelVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[49] || (_cache[49] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_0
          })
        ], -1)),
        _cache[50] || (_cache[50] = _createElementVNode("div", { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }, " 是否确认删除此需求？ ", -1)),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogDelVisible) //@ts-ignore
 ? dialogDelVisible.value = false : dialogDelVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: dlt
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(dialogCooperationVisible),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(dialogCooperationVisible) ? (dialogCooperationVisible).value = $event : dialogCooperationVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[52] || (_cache[52] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_0
          })
        ], -1)),
        _cache[53] || (_cache[53] = _createElementVNode("div", { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }, " 确认要终止合作吗？ ", -1)),
        _cache[54] || (_cache[54] = _createElementVNode("div", { style: {"margin":"0.16rem 0","color":"#86909c","text-align":"center"} }, " 终止合作，平台将扣除2%的费用 ", -1)),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(dialogCooperationVisible) //@ts-ignore
 ? dialogCooperationVisible.value = false : dialogCooperationVisible = false))
          }, " 取消 "),
          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "dataBtnSubmit" }, "确认", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "合作评价",
      modelValue: _unref(dialogEvaluateVisible),
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(dialogEvaluateVisible) ? (dialogEvaluateVisible).value = $event : dialogEvaluateVisible = $event)),
      "align-center": "",
      "before-close": handleClose1,
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[55] || (_cache[55] = _createElementVNode("div", { style: {"color":"#86909c","font-size":"0.14rem","text-align":"center","margin-bottom":"0.18rem"} }, " 评价星级 ", -1)),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_el_rate, {
            modelValue: _unref(evaluateObj).evaluateStar,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(evaluateObj).evaluateStar) = $event)),
            size: "large"
          }, null, 8, ["modelValue"])
        ]),
        _cache[56] || (_cache[56] = _createElementVNode("div", { style: {"color":"#000000","margin-bottom":"0.16rem","font-size":"0.14rem"} }, " 评价内容 ", -1)),
        _createVNode(_component_el_input, {
          modelValue: _unref(evaluateObj).evaluateContent,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(evaluateObj).evaluateContent) = $event)),
          maxlength: "30",
          placeholder: "输入评价内容",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[9] || (_cache[9] = ($event: any) => {
          _isRef(evaluateObj) //@ts-ignore
 ? evaluateObj.value = {} : evaluateObj = {};
        _isRef(dialogEvaluateVisible) //@ts-ignore
 ? dialogEvaluateVisible.value = false : dialogEvaluateVisible = false;
        })
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: evaluate
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "结算",
      modelValue: _unref(dialogAccountVisible),
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(dialogAccountVisible) ? (dialogAccountVisible).value = $event : dialogAccountVisible = $event)),
      "align-center": "",
      width: "50%",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(settlementObj).projectName), 1),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", null, "工作地点： " + _toDisplayString(_unref(settlementObj).workPlace), 1),
          _createElementVNode("div", null, " 交付时间：" + _toDisplayString(_unref(com_date).com_date.timestamp_string(
              _unref(settlementObj).deliveryTime,
              false,
              "-",
              ":"
            )), 1),
          _createElementVNode("div", null, "技能类型：" + _toDisplayString(_unref(settlementObj).skillType), 1)
        ]),
        _cache[59] || (_cache[59] = _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#86909c","margin-bottom":"0.12rem"} }, " 需求描述 ", -1)),
        _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(settlementObj).projectDescription), 1),
        _cache[60] || (_cache[60] = _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#86909c","margin-bottom":"0.12rem","margin-top":"0.24rem"} }, " 交付文件 ", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settlementObj).deliveryFile, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"background":"#f7f8fa","padding":"0.12rem","display":"flex","justify-content":"space-between"},
            key: index
          }, [
            _createElementVNode("div", _hoisted_53, [
              _cache[57] || (_cache[57] = _createElementVNode("div", { class: "fileIcon" }, null, -1)),
              _createVNode(Tooltip, {
                style: {"width":"0.7rem"},
                text: item.name
              }, null, 8, ["text"])
            ]),
            _createElementVNode("a", {
              class: "downloadIcon",
              href: item.url
            }, null, 8, _hoisted_54)
          ]))
        }), 128)),
        _cache[61] || (_cache[61] = _createElementVNode("div", { style: {"border-bottom":"1px solid #e5e6eb","margin-bottom":"0.2rem"} }, null, -1)),
        _createElementVNode("div", _hoisted_55, [
          _cache[58] || (_cache[58] = _createElementVNode("div", { style: {"color":"#333333","font-size":"0.14rem","margin-top":"0.09rem"} }, " 结算金额： ", -1)),
          _createElementVNode("div", _hoisted_56, " ￥" + _toDisplayString((_unref(settlementObj).price / 1).toFixed(2)), 1)
        ]),
        _cache[62] || (_cache[62] = _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#86909c","margin":"0.2rem 0"} }, " 结算后，您在平台托管的金额将发放给合作者 ", -1)),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_isRef(dialogAccountVisible) //@ts-ignore
 ? dialogAccountVisible.value = false : dialogAccountVisible = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: SettleAnAccount
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "查看文件",
      modelValue: _unref(dialogAccountViewVisible),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(dialogAccountViewVisible) ? (dialogAccountViewVisible).value = $event : dialogAccountViewVisible = $event)),
      "align-center": "",
      width: "50%",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[64] || (_cache[64] = _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#86909c","margin-bottom":"0.12rem"} }, " 交付文件 ", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settlementObj).deliveryFile, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"background":"#f7f8fa","padding":"0.12rem","display":"flex","justify-content":"space-between"},
            key: index
          }, [
            _createElementVNode("div", _hoisted_58, [
              _cache[63] || (_cache[63] = _createElementVNode("div", { class: "fileIcon" }, null, -1)),
              _createVNode(Tooltip, {
                style: {"width":"0.7rem"},
                text: item.name
              }, null, 8, ["text"])
            ]),
            _createElementVNode("a", {
              class: "downloadIcon",
              href: item.url
            }, null, 8, _hoisted_59)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "报名人数",
      modelValue: _unref(peopleVisible),
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(peopleVisible) ? (peopleVisible).value = $event : peopleVisible = $event)),
      "align-center": "",
      width: "600px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(numberOfApplicants)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: title1.value,
      modelValue: _unref(peopleSelectVisible),
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(peopleSelectVisible) ? (peopleSelectVisible).value = $event : peopleSelectVisible = $event)),
      "align-center": "",
      width: "600px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list1.value, (item, index) => {
          return (_openBlock(), _createBlock(numberOfApplicantsSelect, {
            key: index,
            item: item,
            type: title1.value == '查看合伙人' ? 1 : 0,
            onClick: ($event: any) => (selectPeople(item)),
            ref_for: true,
            ref_key: "numberOfApplicantsSelectRef",
            ref: numberOfApplicantsSelectRef
          }, null, 8, ["item", "type", "onClick"]))
        }), 128)),
        _createElementVNode("div", _hoisted_60, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            total: form.value.total
          }, null, 8, ["total"])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_isRef(peopleSelectVisible) //@ts-ignore
 ? peopleSelectVisible.value = false : peopleSelectVisible = false))
          }, " 取消 "),
          (title1.value != '查看合伙人')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "dataBtnSubmit",
                onClick: handlePay
              }, " 确认 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "付款",
      modelValue: _unref(payVisible),
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(payVisible) ? (payVisible).value = $event : payVisible = $event)),
      "align-center": "",
      width: "500px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[67] || (_cache[67] = _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#86909c","text-align":"center","margin-bottom":"0.16rem"} }, " 支付项目费用到平台担保，并获得创作者联系方式 ", -1)),
        _createElementVNode("div", _hoisted_62, [
          _cache[65] || (_cache[65] = _createTextVNode(" 应付金额： ")),
          _cache[66] || (_cache[66] = _createElementVNode("span", { style: {"color":"#c01a26"} }, " ￥ ", -1)),
          _createElementVNode("span", _hoisted_63, _toDisplayString((Payment.value.price / 1).toFixed(2)), 1)
        ]),
        _cache[68] || (_cache[68] = _createElementVNode("div", { style: {"font-size":"0.14rem","margin-bottom":"0.12rem","color":"#000000"} }, " 选择支付方式 ", -1)),
        _createElementVNode("div", _hoisted_64, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentOptions.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["payItem", { selected: selectedPaymentOption.value === item }]),
              key: index,
              onClick: ($event: any) => (selectPaymentOption(item))
            }, [
              _createElementVNode("div", _hoisted_66, [
                (item.name == '微信')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_67))
                  : (_openBlock(), _createElementBlock("img", _hoisted_68))
              ]),
              _createElementVNode("div", null, _toDisplayString(item.name), 1)
            ], 10, _hoisted_65))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_isRef(payVisible) //@ts-ignore
 ? payVisible.value = false : payVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: Payment1
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(cooperationVisible),
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(cooperationVisible) ? (cooperationVisible).value = $event : cooperationVisible = $event)),
      "align-center": "",
      width: "580px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[70] || (_cache[70] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_0
          })
        ], -1)),
        _cache[71] || (_cache[71] = _createElementVNode("div", { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }, " 是否确认与此创作者进行合作？合作后平台将扣除3%手续费？ ", -1)),
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.radio2,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.radio2) = $event)),
            style: {"margin-top":"-0.03rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, { size: "small" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _cache[69] || (_cache[69] = _createElementVNode("div", { style: {"color":"#333333"} }, "已阅读并同意", -1)),
          _createElementVNode("div", {
            style: {"color":"#c01a26"},
            onClick: _cache[20] || (_cache[20] = ($event: any) => (openagreement('yyfwxy')))
          }, " 《标识山西扣费协议》 ")
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_isRef(cooperationVisible) //@ts-ignore
 ? cooperationVisible.value = false : cooperationVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: Verify
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      "close-on-click-modal": false,
      modelValue: _unref(serviceVisible),
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(serviceVisible) ? (serviceVisible).value = $event : serviceVisible = $event)),
      "align-center": "",
      width: "580px"
    }, {
      default: _withCtx(() => [
        _cache[72] || (_cache[72] = _createElementVNode("div", { style: {"text-align":"center"} }, [
          _createElementVNode("img", {
            style: {"width":"1.8rem","margin":"0 auto","height":"1.8rem","border-radius":"0.12rem","border":"1px solid #e5e6eb"},
            src: _imports_3,
            alt: ""
          })
        ], -1)),
        _cache[73] || (_cache[73] = _createElementVNode("div", { style: {"text-align":"center","margin-top":"0.12rem","margin-bottom":"0.2rem","font-size":"0.14rem","color":"#333333"} }, " 扫描二维码，添加客服微信号 ", -1)),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_isRef(serviceVisible) //@ts-ignore
 ? serviceVisible.value = false : serviceVisible = false))
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "评价内容",
      modelValue: dialogEvaluateVisible1.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((dialogEvaluateVisible1).value = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[74] || (_cache[74] = _createElementVNode("div", { style: {"color":"#86909c","font-size":"0.14rem","text-align":"center","margin-bottom":"0.18rem"} }, " 评价星级 ", -1)),
        _createElementVNode("div", _hoisted_73, [
          _createVNode(_component_el_rate, {
            disabled: "",
            modelValue: EvaluationContentObj.value.evaluateStar,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((EvaluationContentObj.value.evaluateStar) = $event)),
            size: "large"
          }, null, 8, ["modelValue"])
        ]),
        _cache[75] || (_cache[75] = _createElementVNode("div", { style: {"color":"#000000","margin-bottom":"0.16rem","font-size":"0.14rem"} }, " 评价内容 ", -1)),
        _createVNode(_component_el_input, {
          modelValue: EvaluationContentObj.value.evaluateContent,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((EvaluationContentObj.value.evaluateContent) = $event)),
          maxlength: "30",
          disabled: "",
          placeholder: "输入评价内容",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[27] || (_cache[27] = ($event: any) => {
          EvaluationContentObj.value = {};
        dialogEvaluateVisible1.value = false;
        })
          }, " 取消 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: title2.value,
      "before-close": handleClose,
      "close-on-click-modal": false,
      modelValue: checked.value,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((checked).value = $event)),
      "align-center": "",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form1.value,
          "label-width": "100px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "项目名称",
              prop: "projectName",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form1.value.projectName,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form1.value.projectName) = $event)),
                  disabled: title2.value == '查看发布需求',
                  placeholder: "请填写项目名称"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "项目描述",
              prop: "projectDescription"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  disabled: title2.value == '查看发布需求',
                  modelValue: form1.value.projectDescription,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((form1.value.projectDescription) = $event)),
                  placeholder: "填写详细的描述，可更准确快速匹配合适创作人，可含：需求背景、时长、风格、投放渠道等..."
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系方式",
              prop: "contactInfo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form1.value.contactInfo,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((form1.value.contactInfo) = $event)),
                  disabled: title2.value == '查看发布需求',
                  placeholder: "请填写联系方式"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "预算价格",
              prop: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  oninput: "value=value.replace(/[^\\d.]/g, '')",
                  modelValue: form1.value.price,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((form1.value.price) = $event)),
                  disabled: title2.value == '查看发布需求',
                  placeholder: "请输入价格"
                }, {
                  append: _withCtx(() => _cache[76] || (_cache[76] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "交付日期",
                      prop: "deliveryTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: form1.value.deliveryTime,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((form1.value.deliveryTime) = $event)),
                          disabled: title2.value == '查看发布需求',
                          type: "date",
                          format: "YYYY-MM-DD",
                          "value-format": "x",
                          placeholder: "选择交付日期",
                          "disabled-date": disabledDate
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "工作地点",
                      prop: "workPlace"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form1.value.workPlace,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((form1.value.workPlace) = $event)),
                          disabled: title2.value == '查看发布需求',
                          placeholder: "请输入工作地点"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "技能类型",
              prop: "skillType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form1.value.skillType,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((form1.value.skillType) = $event)),
                  disabled: title2.value == '查看发布需求',
                  placeholder: "请输入技能类型"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (title2.value != '查看发布需求')
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: radio.value,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((radio).value = $event))
                  }, null, 8, ["modelValue"]),
                  _cache[77] || (_cache[77] = _createElementVNode("div", { style: {"color":"#333333","margin-left":"0.1rem"} }, "已阅读并同意", -1)),
                  _createElementVNode("div", {
                    style: {"color":"#c01a26"},
                    onClick: _cache[37] || (_cache[37] = ($event: any) => (openagreement('zywsyxy')))
                  }, " 《找业务使用协议》 ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", {
            class: "dataBtn dataBtnQx",
            style: {"cursor":"pointer"},
            onClick: _cache[38] || (_cache[38] = ($event: any) => (handleClose()))
          }, "取消"),
          (title2.value != '查看发布需求')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "dataBtn",
                style: {"cursor":"pointer"},
                onClick: _cache[39] || (_cache[39] = ($event: any) => (submitForm()))
              }, " 确认发布 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "合作者手机号",
      modelValue: PartnersMobileNumber.value,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((PartnersMobileNumber).value = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[78] || (_cache[78] = _createElementVNode("div", { style: {"text-align":"center"} }, "联系方式", -1)),
        _createElementVNode("div", _hoisted_77, _toDisplayString(PartnersMobileNumber1.value), 1),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[41] || (_cache[41] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: _cache[42] || (_cache[42] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 确认 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(TwoDimensionalCode, {
      ref_key: "TwoDimensionalCodeRef",
      ref: TwoDimensionalCodeRef,
      CloseQrCode: CloseQrCode
    }, null, 512)
  ]))
}
}

})